import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axiosInstance from './utils/http'

import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);
Vue.use(ElementUI)

Vue.prototype.$axios = axiosInstance
Vue.config.productionTip = false

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
